import React from "react";
import { CCard, CRow, CCardBody } from "@coreui/react";
import { Button } from "semantic-ui-react";
import BarChartHolding from "./BarChartHolding";

const ChartCardHolding = (props) => {

  const { period, setPeriod } = props

  return (
    <>
      <div>
        <CCard className="" style={{ border: "none", margin: 0 }}>
          <CCardBody>
            <CRow className="d-flex justify-content-center">
              <Button.Group size="medium" style={{
                color: "#F3F4F6",
                maxWidth: "35%",
              }}>
                <Button
                  className="!tw-m-0 tw-w-[100px]"
                  onClick={() => setPeriod("year")}
                  active={period == "year"}
                >
                  Anual
                </Button>
                <Button
                  className="!tw-m-0 tw-w-[100px]"
                  onClick={() => setPeriod("semester")}
                  active={period == "semester"}
                >
                  Semestral
                </Button>
                <Button
                  className="!tw-m-0 tw-w-[100px]"
                  onClick={() => setPeriod("quarter")}
                  active={period == "quarter"}
                >
                  Trimestral
                </Button>
              </Button.Group>
            </CRow>
            <div className="mxHeight">
              <BarChartHolding
                labels={props.labels}
                data={props.data}
                tooltip={props.tooltip}
                setHidden={props.setHidden}
                isSale={props.isSale}
              />
            </div>
          </CCardBody>
        </CCard>
      </div>
    </>
  );
};

export default ChartCardHolding;
